// Utilidades compartidas para descargar los Excel de una jornada.
import { coincideJornada } from "./SelectorJornada";

// Parámetros: siempre la comunidad y la jornada en la que se está.
export const paramsJornada = (ctx, filtroJornada) => ({
  territorio: ctx?.territorio,
  comunidad: ctx?.comunidad,
  ...(filtroJornada && filtroJornada !== "__sin__" ? { jornada: filtroJornada } : {}),
});

// Nombre del archivo: Tipo_Comunidad_Jornada[_filtrado].xlsx
export const nombreExcel = (prefijo, ctx, jornadas, filtroJornada, filtrado) => {
  const j = (jornadas || []).find((x) => coincideJornada(x.codigo, filtroJornada));
  const etiqueta = !j ? "jornada" : j.origen === "historica" ? "historica" : `jornada_${String(j.fecha_inicio || "").slice(0, 10)}`;
  return [prefijo, ctx?.comunidad, etiqueta, filtrado ? "filtrado" : null]
    .filter(Boolean).join("_").replace(/[^\wÁÉÍÓÚáéíóúÑñ-]+/g, "_") + ".xlsx";
};

export const descargarBlob = (data, nombre) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.setAttribute("download", nombre);
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
